/* eslint-disable */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index'
import store from '@/store'
import { SetupCalendar,  DatePicker } from 'v-calendar'
import 'v-calendar/dist/style.css'
import VueElementLoading from "vue-element-loading"
import VueGtag from 'vue-gtag'

// MDB(JS)
// import 'mdb-ui-kit/js/mdb.min.js'
// import 'mdb-ui-kit/css/mdb.min.css'

createApp(App)
  .use(router, SetupCalendar, {})
  .use(store)
  .use(VueGtag, { config: { id: 'G-FQB4JGHBEJ'} }, router)
  .component("DatePicker", DatePicker)
  .component("VueElementLoading", VueElementLoading)
  .mount('#app')
